import React from "react";
import DragDrop from "../components/DragDrop";
import ColorPicker from "../components/ColorPicker";

const ReadFromPicture = () => {
  return (
    <main>
      <DragDrop />
    </main>
  );
};

export default ReadFromPicture;
